import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <p><strong>Description</strong></p>
     <p>Your station has qualified as a bottom performing station for the number of <strong>Following Distance</strong>, On-Road Safety Alerts alerts encountered during the previous week. The intentions of this alert is to spread awareness and additional information at daily standups to DSP’s pertaining to OTR safety, in an effort to reduce unsafe driving within your station and community.</p>
     <p><strong>Station Actions</strong></p>
     <ol>
        <li>Reference the left hand details of the SIM to see which DSPs has high rates of <strong>Following Distance</strong> violations</li>
        <li>Reach out to these DSPs to communicate best practices</li>
        <li>Close the exception</li>
     </ol>
     <p><strong>Impact</strong></p>
     <p>On-Road Safety Alerts encourages the OTR leaders to perform stand up communications emphasizing this bottom performing metric and tips on safe driving to reduce the number of alerts and help support improvement to the DSP's scorecard metrics.</p>
     <p><strong>Following Distance Safety Tips for DAs:</strong></p>
     <ul>
        <li>As a Professional Driver, you must make the personal commitment to eliminate driving habits not in accordance with professional driver standards, before and during vehicle operation. Safe behavior protects you, your family, and the community that has entrusted us with operating safely within their neighborhoods.</li>
        <li>Drive defensively/conservatively. Maintain safe distance to allow for unexpected circumstances (sudden braking, lane merging, distracted driver lane weaving, pedestrians/animals, etc.). Double following distance in adverse weather/road conditions.</li>
        <li>Continually adjust distance – If another vehicle merges in front of you, immediately slow down to re-establish adequate distance.</li>
     </ul>
     <p><strong>Best Practices for DSPs</strong></p>
    <ul>
        <li>Use the DSP Safety Dashboard or Netradyne Portal’s Driver page to understand which DAs have the most events.</li>
        <li>Coach DAs on a daily basis using video evidence available in the Netradyne Portal.</li>
        <li>Help DAs to understand the safety impact this provides for them and the communities they drive in.</li>
     </ul>
     <p><strong>Supplemental Links</strong></p>
     <ol>
        <li><span class="wikiinternallink"><a href="https://alchemy.aka.amazon.com/#/site/AMZL/views/ORSADashboard/Volume?:iid=1">ORSA Dashboard</a></span></li>
        <li><span class="wikiinternallink"><a href="https://w.amazon.com/bin/view/Users/shilpkri/new_wiki_page_with_stuff/">On-Road Safety Alerts Wiki</a></span></li>
     </ol>
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Following_Distance_Coaching_for_ORSA.jsx